<script setup>
import AppLayout from "../../Layouts/AppLayout.vue";
import {usePage} from "@inertiajs/inertia-vue3";
import SecondaryButton from "../../Components/SecondaryButton.vue";
import MediaUpload from "../../Components/Common/Media/MediaUpload.vue";
import {useHelpers} from "../../helpers";

defineProps({
  media: Object
})
const helpers = useHelpers();
const currentUser = usePage().props.value.auth.user;
</script>

<template>
  <AppLayout title="Accounting">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Accounting
      </h2>
    </template>

    <div class="max-w-full py-10 sm:px-6 lg:px-8">
      <MediaUpload
        :media-input="media"
        :can-see-upload-form="helpers.userHasPermission(currentUser, 'admin')"
        :can-modify-media-details="helpers.userHasPermission(currentUser, 'admin')"
        :hide-save="false"
        media-location="accounting"
      ></MediaUpload>
    </div>
  </AppLayout>
</template>
